import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export const jsonMixin = {
    components: {
        VueJsonPretty
    },
    methods: {
        isJSON(value) {
            try {
                JSON.parse(value);
                return true;
            } catch (e) {
                return false;
            }
        }
    }
};
